/**
 * .tuMetrics {"tu1": 0.93, "tu2": 0.95, "tu3": 2, "notes": "Auth bootstrap decision after session + membership", "tuVersion": "2.5"}
 * .help "After login: deactivated users are signed out; unaccepted invites skip company data; everyone else bootstraps."
 */

export type AuthBootstrapDecision =
  | 'sign_out_deactivated'
  | 'skip_company_data'
  | 'load_company_data';

export function authBootstrapDecision(input: {
  deactivated: boolean;
  inviteAccepted: boolean;
}): AuthBootstrapDecision {
  if (input.deactivated) return 'sign_out_deactivated';
  if (!input.inviteAccepted) return 'skip_company_data';
  return 'load_company_data';
}

/** Store fields cleared on logout / deactivated sign-out (push hook watches currentUser.id). */
export function clearedAuthSlice(): {
  currentUser: null;
  isAuthenticated: false;
  isLoadingAuth: false;
  coreDataReady: false;
  allUsers: [];
  hasInitializedAuth: false;
  isTokenRefreshing: false;
} {
  return {
    currentUser: null,
    isAuthenticated: false,
    isLoadingAuth: false,
    coreDataReady: false,
    allUsers: [],
    hasInitializedAuth: false,
    isTokenRefreshing: false,
  };
}

export type AuthChangeEventName = string;

/** Refresh failure / explicit sign-out: session is gone; do not linger as anon realtime. */
export function isAuthSessionLost(
  event: AuthChangeEventName,
  session: { access_token?: string } | null | undefined,
): boolean {
  if (event === 'SIGNED_OUT') return true;
  if (event === 'TOKEN_REFRESHED' && !session) return true;
  return false;
}

export function shouldRedirectToLogin(pathname: string): boolean {
  return !pathname.startsWith('/login') && !pathname.startsWith('/signup') && !pathname.startsWith('/invite');
}
